import React from 'react';

export default function AuthenticityToken() {
  return <input type="hidden" defaultValue={document.querySelector('meta[name="csrf-token"]').getAttribute('content')} name="authenticity_token"/>
}